const MarkerMap = {
  'circle': '●',
  'diamond': '♦',
  'square': '■',
  'triangle': '▲',
  'triangle-down': '▼'
};

export default MarkerMap;